import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAdminTabs } from '@/groups/coordinator/useAdminTabs';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/admin/',
)({
  component: GroupAdminIndex,
});

/**
 * `/admin/` is a redirect, not a screen — legacy has no screen there either.
 *
 * `class-groups-overrides.php:302-311` prunes the `Manage` subnav and then
 * `bp_core_redirect(current($secondary_items))` to whatever survived first, so
 * the target is group-type dependent: measured with
 * `curl -w '%{http_code} -> %{redirect_url}'`, a study group, a congregation and
 * both follow-up types land on `.../admin/group-avatar/`, while a custom study
 * group and a social group land on `.../admin/edit-details/` — a screen web does
 * not have. `useAdminTabs` is the same pruned list, so its first entry is this
 * app's equivalent of `current($secondary_items)`.
 *
 * `/admin/` is also what both sidebars now link `Settings` at, which is why this
 * has to exist rather than each sidebar hardcoding a leaf.
 */
function GroupAdminIndex(): null {
  const { groupName } = Route.useParams();
  const navigate = useNavigate();
  const tabs = useAdminTabs();
  const firstTab = tabs[0]?.to;

  useEffect(() => {
    if (!firstTab) return;
    navigate({
      to: `/groups/$groupName/admin/${firstTab}`,
      params: { groupName },
      replace: true,
    });
  }, [firstTab, groupName, navigate]);

  return null;
}
